import { useApplicationPermissions } from '@atlassian/jira-tenant-context-controller/src/components/application-permissions/index.tsx';

export const useIsReadOnly = () => {
	const { hasProductDiscoveryAccess } = useApplicationPermissions();
	return !hasProductDiscoveryAccess;
};
